const protocols = [
    {label: 'ALL', has: () => true},
    {label: 'SAML', has: app => app.isSaml},
    {label: 'MFA ADAPTER / RADIUS / RDP / VPN', has: app => app.isRadius || app.isMfaAdapter || app.isVpnRdp},
    {label: 'PROVISIONING', has: app => app.provisioningSupported}
];

const allProtocols = protocols[0];
const allCategories = {name: 'All'};

export class Controller {

    /** @ngInject */
    constructor(
        $state,
        $filter,
        $timeout,
        AddApplicationModal,
        AddNewApplicationResource,
    ) {
        this.state = $state;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.AddApplicationModal = AddApplicationModal;
        this.AddNewApplicationResource = AddNewApplicationResource;
    }

    $onInit() {
        this.protocol = allProtocols;
        this.protocols = protocols;
        this.category = allCategories;
        this.categories = [allCategories, ...this.appCategories];
        this.samlAppLogo = window.env.urls.samlAppLogo;
        this.searchText = '';
        
        this.filteredAppTypes = [];
        setTimeout(() => {
            /*
            * This small delay is added because of smart table pagination.
            * If it is loading for the first time after refreshing page.
            * It was loading all application types and then applying pagination.
            */
            this.applyFilters()
        }, 100);
        localStorage.setItem(`items-per-page:${this.state.current.name}`, 50);
    }

    applyFilters() {
        this.filteredAppTypes = [];
        this.$timeout()
            .then(() => this.appTypes)
            .then(apps => apps.filter(app => this.protocol.has(app)))
            .then(apps => apps.filter(app => this.categoryHas(app)))
            .then(apps => this.$filter('filter')(apps, this.searchText))
            .then(apps => {
                this.filteredAppTypes = apps;
            });
    }

    categoryHas(app) {
        return this.category === allCategories ||
            this.category.aTIds.includes(+app.id);
    }

    handleSearchChange() {
        this.protocol = allProtocols;
        this.category = allCategories;
        this.applyFilters();
    }

    selectCategory(category) {
        this.category = category;
        this.searchText = '';
        this.applyFilters();
    }

    selectProtocol(protocol) {
        this.protocol = protocol;
        this.searchText = '';
        this.applyFilters();
    }

    showAddApplicationModal(app) {
        if (app.slug === 'office-365') {
            this.AddApplicationModal(app);
            return;
        }
        this.isLoading = true;
        this.AddNewApplicationResource
            .createSecureApp(this.companyId, app.id)
            .then(app => this.state.go('company.manage-application', {appId: app.id}))
            .finally(() => this.isLoading = false);
    }
    checkIfAdd(app) {
        var isSra=app.slug==='saaspass-secure-remote-access';
        var isAdPasswordManager=app.slug==='ad-password-manager';

        var isSraAllowed=this.appPermissions.sra;
        var isAdPasswordManagerAllowed=this.appPermissions.adPasswordManager;

        var allowAdd=!((isSra && !isSraAllowed) || (isAdPasswordManager && !isAdPasswordManagerAllowed));
        return allowAdd;
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-applications/supported-application-types/supported-application-types.controller.js